import {Component, OnInit, ViewChild, HostListener} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, Amenity} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import { Router } from '@angular/router';
import { ResidentService } from '../../../services/resident.service';
import {MaintenanceCalendarService} from '../../../services/maintenance-calendar.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'maintenance-calendar-modal',
    templateUrl: './maintenance-calendar-modal.component.html',
    styleUrls: ['./maintenance-calendar-modal.component.scss']
})
export class MaintenanceCalendarModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: Amenity = new Amenity();
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    hours = MaintenanceCalendarModalComponent.parseTime((new Date()).toISOString());
    buildingSelectIsDisabled = false;
    isEditModeNoSpinner = false;
    timeSlotSelectValues: Array<any> = [];
    timeRangeSelectValues: Array<any> = [];
    selectedDayBookings: Array<any> = [];
    selectedEndDayBookings: Array<any> = [];
    fullResidentsObjectArray: Array<any> = [];
    step = 'amenity';
    showCalendarDatePicker = false;
    calendarOptions: any;
    monthsArray: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    cardMonthArray:  Array<string> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    arrayOfMonthsLastDays:  Array<number> = [
        31,
        new Date().getFullYear() % 4 == 0 ? 29 : 28,
        31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    cardYearsArray:  Array<number> = [];
    payment = {
        cardHolderName: '',
        postalCode: '',
        creditCardNumber: '',
        cardMonth: '',
        cardYear: '',
        cvv: '',
        reservationFee: '',
        securityDeposit: ''
    };
    events = [];
    amenityType = '';
    startHour = '';
    endHour = '';
    daySelectedNumber = null;
    timeSlot = '';
    showTimeSelectSpinner = false;
    residentEmail = '';
    residentPhone = '';
    termsAndConditions = '';
    dateToSet = '';
    amenityName = '';
    amenityConfirmationMessage = '';
    disclaimerText= '';
    disclaimerHideFromStaffInterface: any ;
    disclaimerStatus: any;
    legalAgreementStatus: any;
    arrayForCalendarColoring: Array<any> = [];
    showCalendarSpinner = false;
    note = '';
    isEditMode = false;
    bookingMaxHour = null;
    bookingMinHour = null;
    bookingType = 'booking';
    testValues = [{id: 1, itemName: '1'}, {id: 2, itemName: '2'}];
    testValue = [];
    showCustomRepeatWindow = false;
    ends = 'never';
    repeatOn = [];
    endOn = new Date();
    checkInHour = '';
    checkOutHour = '';
    originalRules = null;
    availablePaymentMethods = [];
    amenityFees = [];
    creditCardToken: any;
    gettingAmenityForEditing = false;
    nextDayEndTimes = [];
    availableUses = [];
    overrideAvailable = false;
    multipleBookingAllowed = false;
    paymentMethodSelectDisabled = false;
    confirmationSpinner = false;
    eventName = '';
    maxNumberOfParticipants = null;
    minTimeForAdvancedBooking = null;

    taskName = '';
    currentTime = new Date();
    repeat = false;
    notificationInteger = 0;
    reminders = false;
    email = '';

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public maintenanceCalendarService: MaintenanceCalendarService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private router: Router,
        private residentService: ResidentService
    ) {}

    ngOnInit() {
        if(!this.maintenanceCalendarService.buildings.length)
            this.maintenanceCalendarService.getBuildings();
        this.maintenanceCalendarService.amenitiesListForModal = [];
        this.initData();
        const currentYear = new Date().getFullYear();
        for(let i = currentYear - 10; i < currentYear + 11; i++)
            this.cardYearsArray.push(i);
        this.calendarOptions = {
            editable: true,
            displayEventEnd: true,
            eventLimit: 4,
            timeFormat: 'h:mma',
            displayEventTime: true,
            showNonCurrentDates: false,
            fixedWeekCount: false,
            header: {
                left: '',
                center: 'prev,title,next',
                right: ''
            },
            events: this.events
        };
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.isEditModeNoSpinner = false;
        if (this.maintenanceCalendarService.amenityInAmenityModal  && !this.maintenanceCalendarService.isPrefilledFromDirectory) {
            this.data = Object.assign({}, this.maintenanceCalendarService.amenityInAmenityModal);
            if(typeof this.data.suiteId == 'string') {
                if((<any>this.data.suiteId).indexOf('-') != -1) {
                    this.data.suiteId = 0;
                    this.data.residentId = 0;
                }
            } else {
                if(this.data.suiteId.toString().indexOf('-') != -1) {
                    this.data.suiteId = 0;
                    this.data.residentId = 0;
                }
            }
            this.step = 'details';
            this.amenityName = '';
            this.amenityType = '';
            this.isEditMode = true;
            this.gettingAmenityForEditing = true;
            const url = `/v1/amenity/${this.maintenanceCalendarService.amenityInAmenityModal.amenityId}.json?expand=buildingAmenity,fees`;
            this.api.get('domainAmenities', `${url}`).subscribe(
                (res) => {
                    const amenity = JSON.parse(res._body);
                    this.data.amenity = this.data.amenityId;
                    this.amenityName = amenity.name;
                    this.amenityType = amenity.timeSequenceType;
                    this.originalRules = amenity.rule;
                    this.availableUses = amenity.uses;
                    this.overrideAvailable = amenity.managementOverride;
                    this.multipleBookingAllowed = amenity.multipleBooking;
                    this.minTimeForAdvancedBooking = amenity.minTimeForAdvancedBooking;
                    if(!this.data.uses && this.availableUses.length)
                        this.data.uses = this.availableUses[0];
                    if(amenity.defaultPaymentMethod)
                        this.data.paymentMethod = amenity.defaultPaymentMethod;
                    if(amenity.fees && this.bookingType != 'event') {
                        amenity.fees.filter((fee) => {
                            if(fee.active) {
                                if (fee.status)
                                    this.paymentMethodSelectDisabled = true;
                                this.amenityFees.push({
                                    id: fee.id,
                                    active: fee.active,
                                    name: fee.name,
                                    status: fee.status,
                                    amount: fee.amount,
                                    required: fee.required,
                                    include: fee.required ? true : false,
                                    refundable: fee.refundable,
                                    pmtAtTime: fee.pmtAtTime,
                                    pmtHourly: fee.pmtHourly
                                });
                            }
                        });
                        this.data.payments.filter((payment) => {
                            if(payment.paymentType)
                                this.data.paymentMethod = payment.paymentType;
                            this.amenityFees.filter((fee) => {
                                if(fee.name == payment.name && fee.status != payment.status) {
                                    fee.status = payment.status;
                                    if(fee.status)
                                        this.paymentMethodSelectDisabled = true;
                                }
                                if(fee.name == payment.name && fee.include != payment.chosen)
                                    fee.include = payment.chosen;
                            });
                        });
                    }
                    if(amenity.paymentAcceptCash)
                        this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
                    if(amenity.paymentAcceptCheques)
                        this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
                    if(amenity.paymentAcceptCreditCards)
                        this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
                    if(amenity.paymentAcceptCustomType)
                        this.availablePaymentMethods.push({value: 'custom_type', displayName: amenity.paymentCustomTypeName});
                    if(amenity.legalAgreementStatus && !amenity.legalAgreementHideFromStaffInterface) {
                        this.termsAndConditions = amenity.legalAgreement;
                        this.disclaimerText = amenity.disclaimer;
                        this.disclaimerHideFromStaffInterface = amenity.disclaimerHideFromStaffInterface;

                        this.amenityConfirmationMessage = amenity.confirmationMessage;
                    }
                    if(amenity.disclaimerStatus && !amenity.disclaimerHideFromStaffInterface)
                        this.disclaimerText = amenity.disclaimer;
                    if(this.amenityType == 'hourly') {
                        this.generateTimeSlotValues(amenity.rule.weekDays, amenity.rule.timeStep);
                        this.bookingMaxHour = amenity.rule.bookingMaxHour;
                        this.bookingMinHour = amenity.rule.bookingMinHour;
                    }
                    if(this.amenityType == 'range') {
                        this.generateRangeSlotValues(amenity.rule.weekDays);
                    }
                    this.daySelectedNumber = new Date(this.data.dateFrom).getDay();
                    const startDay = this.getTimeInZeroTimezone(this.data.dateFrom).getDate();
                    const startMonth = this.getTimeInZeroTimezone(this.data.dateFrom).getMonth() + 1;
                    const startYear = this.getTimeInZeroTimezone(this.data.dateFrom).getFullYear();
                    this.data.day = (startDay > 9 ? startDay : '0' + startDay) + '.' +
                                    (startMonth > 9 ? startMonth : '0' + startMonth) +  '.' + startYear;
                    if(this.amenityType == 'daily') {
                        const endDay = this.getTimeInZeroTimezone(this.data.dateTo).getDate();
                        const endMonth = this.getTimeInZeroTimezone(this.data.dateTo).getMonth() + 1;
                        const endYear = this.getTimeInZeroTimezone(this.data.dateTo).getFullYear();
                        this.data.endDay = (endDay > 9 ? endDay : '0' + endDay) + '.' +
                                           (endMonth > 9 ? endMonth : '0' + endMonth) +  '.' + endYear;
                        this.checkInHour = amenity.rule.checkInTime;
                        this.checkOutHour = amenity.rule.checkOutTime;
                    }
                    if(this.amenityType == 'hourly' || this.amenityType == 'range') {
                        this.getOvernightEndHours();
                        const startTime = this.getTimeInZeroTimezone(this.data.dateFrom);
                        const endTime = this.getTimeInZeroTimezone(this.data.dateTo);
                        if(this.amenityType == 'hourly') {
                            this.startHour = (
                                                 startTime.getHours() <= 12 ?
                                                (startTime.getHours() == 0 ? 12 : (startTime.getHours() < 10 ? '0' + startTime.getHours() : startTime.getHours())) :
                                                ((startTime.getHours() - 12) < 10 ? '0' + (startTime.getHours() - 12) : (startTime.getHours() - 12))
                                             )
                                             + ':' + (startTime.getMinutes() < 10 ? '0' + startTime.getMinutes() : startTime.getMinutes())
                                             + ((startTime.getHours() < 12 || startTime.getHours() == 24) ? ' AM' : ' PM');
                            this.endHour =   (
                                                endTime.getHours() <= 12 ?
                                               (endTime.getHours() == 0 ? 12 : (endTime.getHours() < 10 ? '0' + endTime.getHours() : endTime.getHours())) :
                                               ((endTime.getHours() - 12) < 10 ? '0' + (endTime.getHours() - 12) : (endTime.getHours() - 12))
                                             )
                                             + ':' + (endTime.getMinutes() < 10 ? '0' + endTime.getMinutes() : endTime.getMinutes())
                                             + ((endTime.getHours() < 12 || endTime.getHours() == 24) ? ' AM' : ' PM');
                            const endStartDay = this.getTimeInZeroTimezone(this.data.dateTo).getDate();
                            const endStartMonth = this.getTimeInZeroTimezone(this.data.dateTo).getMonth() + 1;
                            const endStartYear = this.getTimeInZeroTimezone(this.data.dateTo).getFullYear();
                            this.data.endDay = (endStartDay > 9 ? endStartDay : '0' + endStartDay) + '.' +
                                (endStartMonth > 9 ? endStartMonth : '0' + endStartMonth) +  '.' + endStartYear;

                        }
                        if(this.amenityType == 'range') {
                            const leftPart = (
                                                 startTime.getHours() <= 12 ?
                                                (startTime.getHours() == 0 ? 12 : startTime.getHours()) :
                                                startTime.getHours() - 12
                                             )
                                             + ':' + (startTime.getMinutes() < 10 ? '0' + startTime.getMinutes() : startTime.getMinutes())
                                             + ((startTime.getHours() < 12 || startTime.getHours() == 24) ? ' AM' : ' PM');
                            const rightPart = (
                                                 endTime.getHours() <= 12 ?
                                                (endTime.getHours() == 0 ? 12 : endTime.getHours()) :
                                                endTime.getHours() - 12
                                              )
                                              + ':' + (endTime.getMinutes() < 10 ? '0' + endTime.getMinutes() : endTime.getMinutes())
                                              + ((endTime.getHours() < 12 || endTime.getHours() == 24) ? ' AM' : ' PM');
                            this.timeSlot = leftPart + ' - ' + rightPart;
                        }
                        this.showTimeSelectSpinner = true;
                        let startDateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
                        startDateForSending = new Date(new Date(startDateForSending).getTime() - new Date(startDateForSending).getTimezoneOffset() * 60000);
                        let endDateForSending = new Date(new Date(startDateForSending).setDate(new Date(startDateForSending).getDate() + 2));
                        const url = `/v1/booking_schedule.json?start_date=${startDateForSending.toISOString()}&end_date=${endDateForSending.toISOString()}&amenity_id=${this.data.amenity}&result_type=date_from`;
                        this.api.get('domainAmenities', url).subscribe(
                            res => {
                                this.selectedDayBookings = [];
                                JSON.parse(res._body)[0].bookings.filter((booking) => {
                                    if(booking.id != this.data.id)
                                        this.selectedDayBookings.push(booking);
                                });
                                this.selectedEndDayBookings = [];
                                JSON.parse(res._body)[1].bookings.filter((booking) => {
                                    if(booking.id != this.data.id)
                                        this.selectedEndDayBookings.push(booking);
                                });
                                this.showTimeSelectSpinner = false;
                            },
                            error => this.api.errorHandler(error, 'Failed get Bookings for day selected')
                        );
                    }
                    this.gettingAmenityForEditing = false;
                },
                (error) => this.api.errorHandler(error, 'Failed get Amenity For Editing')
            );
            this.isEditModeNoSpinner = true;
            if (this.data.suiteId)
                this.suites = [{id: this.data.suiteId, name: this.data.suiteNumber}];
            else
                this.suites = [{id: 0, name: 'Other'}];
            if (this.data.residentId)
                this.residents = [new ResidentForSelect(this.data.residentId, this.data.residentFullName)];
            else
                this.residents = [new ResidentForSelect(0, 'Other')];
            this.getSuites(this.data.buildingId, this.data.suiteId);
        } else if (this.maintenanceCalendarService.amenityInAmenityModal && this.maintenanceCalendarService.isPrefilledFromDirectory) {
            this.data = Object.assign({}, this.maintenanceCalendarService.amenityInAmenityModal);
            this.maintenanceCalendarService.getAmenitiesListByBuilding(this.data.buildingId);
            this.isEditModeNoSpinner = true;
            this.getSuites(this.data.buildingId, this.data.suiteId);
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
                this.maintenanceCalendarService.buildingsForUpdate.filter((building) => {
                    if(building.id == b)
                        this.data.buildingName = building.name;
                });
                this.maintenanceCalendarService.getAmenitiesListByBuilding(b);
                this.getSuites(this.data.buildingId);
            } else if(this.maintenanceCalendarService.buildings.length > 1) {
                this.data.buildingId = this.maintenanceCalendarService.buildings[0].id;
                this.maintenanceCalendarService.buildingsForUpdate.filter((building) => {
                    if(building.id == this.maintenanceCalendarService.buildings[0].id)
                        this.data.buildingName = building.name;
                });
                this.maintenanceCalendarService.getAmenitiesListByBuilding(this.data.buildingId);
                this.getSuites(this.data.buildingId);
            }

            if (this.maintenanceCalendarService.buildings.length === 1) {
                this.data.buildingId = this.maintenanceCalendarService.buildings[0].id;
                this.maintenanceCalendarService.buildingsForUpdate.filter((building) => {
                    if(building.id == this.maintenanceCalendarService.buildings[0].id)
                        this.data.buildingName = building.name;
                });
                this.maintenanceCalendarService.getAmenitiesListByBuilding(this.data.buildingId);
                this.getSuites(this.data.buildingId);
            }
            if(this.maintenanceCalendarService.prefilledDateFromCaledar) {
                this.data.day = this.maintenanceCalendarService.prefilledDateFromCaledar;
                this.daySelectedNumber = new Date(this.data.day.split('.')[2] + '/' +  this.data.day.split('.')[1] + '/' +  this.data.day.split('.')[0]).getDay();
            }
        }
    }

    hideModal() {
        if ((this.form.dirty && this.form.touched) ||
            (!this.isEditMode && (this.data.amenity || this.data.suiteId ||
             this.data.residentId || this.data.day || this.note || this.data.emailNotification))) {
            swal(ConstantsService.getSwalConfig('Exit without saving?', 'If you close the dialog, the data you have entered will be lost'),
                () => {
                    this.maintenanceCalendarService.isAmenityModalShow = false;
                    this.maintenanceCalendarService.amenityInAmenityModal = null;
                    this.maintenanceCalendarService.isPrefilledFromDirectory = false;
                    this.maintenanceCalendarService.prefilledDateFromCaledar = '';
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.maintenanceCalendarService.isAmenityModalShow = false;
            this.maintenanceCalendarService.amenityInAmenityModal = null;
            this.maintenanceCalendarService.isPrefilledFromDirectory = false;
            this.maintenanceCalendarService.prefilledDateFromCaledar = '';
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit() {
        if(this.data.paymentMethod == 'credit_card' && !this.creditCardToken) {
            toastr.warning('Credit Card details must be entered and applied.');
            return;
        }

        this.disabledSubmit = true;
        const dateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
        const endDateForSending = new Date(parseInt(this.data.endDay.split('.')[2]), parseInt(this.data.endDay.split('.')[1]) - 1, parseInt(this.data.endDay.split('.')[0]));
        let dateFrom;
        let dateTo;
        if(this.amenityType == 'daily') {
            dateFrom = this.convertDayBookingStartEnd(dateForSending, this.checkInHour);
            dateTo = this.convertDayBookingStartEnd(endDateForSending, this.checkOutHour);
        } else if(this.amenityType == 'hourly') {
            dateFrom = this.setDateAndTime(dateForSending, this.startHour);
            dateTo = this.setDateAndTime(endDateForSending, this.endHour);
        } else if(this.amenityType == 'range') {
            const endRangeDay = this.timeSlot.split('- ')[1] == '12:00 AM' ?
                                new Date(new Date(dateForSending).setDate(dateForSending.getDate() + 1)) : dateForSending;
            dateFrom = this.setDateAndTime(dateForSending, this.timeSlot.split(' -')[0]);
            dateTo = this.setDateAndTime(endRangeDay, this.timeSlot.split('- ')[1]);
        }
        let data: any = {
            // type: this.bookingType == 'event' ? 'event' : undefined,
            // event: eventId,
            type: 'booking',
            building: {
                bdId: (Number(this.residentService.selectedBuilding.buildingId)) ||
                        (this.data.buildingId ? this.data.buildingId : 0),
                name: this.residentService.selectedBuilding.buildingName ||
                        (this.data.buildingId ? this.data.buildingName : null)
            },
            suite: {
                bdId: (Number(this.residentService.selectedBuilding.suite_id)) ||
                                (this.data.suiteId ? this.data.suiteId :
                                    (this.data.buildingId + '-' + this.data.suiteNumber).toLowerCase()),
                suiteNumber: (this.residentService.selectedBuilding.suiteNumber) || (this.data.suiteNumber)
            },
            resident: {
                bdId:     (Number(this.residentService.selectedBuilding.residentBdId)) ||
                            (this.data.residentId ? this.data.residentId : 0),
                email:    (this.residentService.selectedBuilding.userEmail) || (this.residentEmail ? this.residentEmail : 'notice@maxcondoclub.ca'),
                fullName: (this.residentService.selectedBuilding.userName) || (this.data.residentFullName),
                isValidEmail: this.data.isValidEmail
            },
            amenity:            this.data.amenity,
            dateFrom:           dateFrom,
            dateTo:             dateTo,
            payments:           this.getPaymentsFormatted(),
            uses:               this.data.uses,
            managementOverride: this.data.managementOverride ? 1 : 0
        };
        if(this.note != '' && (this.note.replace(/&nbsp;/g, '')).replace(/\s/g, '') != '')
            data.notes = [{noteText: this.note}];

        const event = {
            name: this.eventName,
            status: 1,
            amenity: this.data.amenity,
            dateFrom: dateFrom,
            dateTo: dateTo,
            managementOverride: this.data.managementOverride ? 1 : 0,
            maxNumberOfBookings: this.maxNumberOfParticipants
        };

        this.disabledSubmit = true;
        this.confirmationSpinner = true;
        if(this.bookingType != 'event') {
            if (this.data.id) {
                this.api.patch('domainAmenities', `/v1/booking/${this.data.id}.json`, data).subscribe(
                    () => {
                        this.form.reset();
                        this.updateView('Amenity Booking successfully updated');
                    },
                    error => {
                        this.disabledSubmit = false;
                        let errorText = '';
                        const errorBody = JSON.parse(error._body);
                        if (errorBody.errors) {
                            errorBody.errors.filter(error => {
                                errorText += error.description + '. ';
                            });
                        } else
                            errorText = errorBody.message;
                        this.api.errorHandler(error, errorText);
                        this.confirmationSpinner = false;
                    }, () => {
                        this.disabledSubmit = false;
                        this.confirmationSpinner = false;
                    }
                );
            } else {
                this.api.post('domainAmenities', '/v1/booking.json', data).subscribe(
                    () => {
                        this.updateView('Amenity Booking successfully created');
                        this.form.reset();
                    },
                    error => {
                        this.disabledSubmit = false;
                        let errorText = '';
                        const errorBody = JSON.parse(error._body);
                        if (errorBody.errors) {
                            errorBody.errors.filter(error => {
                                errorText += error.description + '. ';
                            });
                        } else
                            errorText = errorBody.message;
                        this.api.errorHandler(error, errorText);
                        this.confirmationSpinner = false;
                    }, () => {
                        this.disabledSubmit = false;
                        this.confirmationSpinner = false;
                    }
                );
            }
        } else {
            this.api.post('domainAmenities', '/v1/event.json', event).subscribe(
                () => {
                    this.updateView('Event has been created successfully');
                    this.form.reset();
                },
                error => {
                    this.disabledSubmit = false;
                    let errorText = '';
                    const errorBody = JSON.parse(error._body);
                    if (errorBody.errors) {
                        errorBody.errors.filter(error => {
                            errorText += error.description + '. ';
                        });
                    } else
                        errorText = errorBody.message;
                    this.api.errorHandler(error, errorText);
                    this.confirmationSpinner = false;
                }, () => {
                    this.disabledSubmit = false;
                    this.confirmationSpinner = false;
                }
            );
        }
    }

    setDateAndTime(dateValue, timeValue): Date {
        const date = new Date(dateValue);
        const timeObj = new Date(`01/01/1970 ${timeValue}`);
        const hours = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        const dateConvertedToZeroTimezone = new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000);
        return dateConvertedToZeroTimezone;
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.maintenanceCalendarService.isAmenityModalShow = false;
        this.maintenanceCalendarService.amenityInAmenityModal = null;
        if(this.router.url !== '/home' && !this.maintenanceCalendarService.isPrefilledFromDirectory)
           this.maintenanceCalendarService.getData();
    }

    changeBuilding(buildingId: string) {
        this.isEditModeNoSpinner = false;
        this.data.amenity = null;
        this.amenityName = '';
        this.amenityType = '';
        this.residentEmail = '';
        this.residentPhone = '';
        this.termsAndConditions = '';
        this.amenityConfirmationMessage = '';
        this.maintenanceCalendarService.buildingsForUpdate.filter((building) => {
            if(building.id == buildingId)
                this.data.buildingName = building.name;
        });
        this.maintenanceCalendarService.getAmenitiesListByBuilding(buildingId);
        this.data.residentId = null;
        this.data.residentFullName = '';
        this.data.suiteId = null;
        this.data.suiteNumber = '';
        this.getSuites(+buildingId);
    }

    changeUnit(suiteId: string) {
        if (+suiteId != this.data.suiteId) {
            this.data.suiteId = +suiteId;
            this.suites.filter((suite) => {if (suite.id == suiteId) this.data.suiteNumber = suite.name; });
            this.isEditModeNoSpinner = false;
            this.form.controls['residentId'].reset();
            this.getResidents(+suiteId);
            if (suiteId + '' === '0') {
                this.form.controls['residentId'].setValue(0);
                this.data.residentId = 0;
                this.data.suiteNumber = '';
                this.data.residentFullName = '';
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            this.residentEmail = '';
            this.residentPhone = '';
        }
    }

    changeResident(residentId: string) {
        this.residentEmail = '';
        this.residentPhone = '';
        this.data.isValidEmail = false;
        this.data.residentId = +residentId;
        this.residents.filter((resident) => {
            if (resident.id == +residentId) {
                this.data.residentFullName = resident.fullName;
                this.residentEmail = resident.email;
                this.data.isValidEmail = resident.isValidEmail;
            }
        });
        this.fullResidentsObjectArray.filter((resident) => {
            if (resident.id == +residentId) {
                resident.phones.forEach(phone => {
                    if(phone.isPrimaryPhone)
                        this.residentPhone = phone.phone;
                });
            }
        });
        this.isEditModeNoSpinner = false;
        if (residentId === '0') this.data.residentFullName = '';
    }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                this.residents = [];
                const suites = JSON.parse(res._body).entities || [];
                suites.forEach(
                    suite => this.suites.push({id: suite.id, name: suite.suiteNumber})
                );
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId)
                    this.getResidents(suiteId);
                else
                    this.residents = [new ResidentForSelect(0, 'Other')];
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
                () => this.buildingSelectIsDisabled = false
        );
    }

    getResidents(suiteId: number): void {
        this.residents = [];
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}&expand=phones`;
        this.api.get('domainBD', url).subscribe(
            res => {
                if (this.data.suiteId !== 0) {
                    this.fullResidentsObjectArray = [];
                    const residents = JSON.parse(res._body).entities;
                    this.fullResidentsObjectArray = residents;
                    residents.forEach(item => {
                        this.residents.push(
                            new ResidentForSelect(item.id, item.fullName, [], item.email, item.isValidEmail)
                        );
                    });
                    this.residents.push(new ResidentForSelect(0, 'Other'));

                    if (this.isEditMode) {
                        this.fullResidentsObjectArray.filter((resident) => {
                            if (resident.id == +this.maintenanceCalendarService.amenityInAmenityModal.residentId) {
                                resident.phones.forEach(phone => {
                                    if (phone.isPrimaryPhone)
                                        this.residentPhone = phone.phone;
                                });
                                this.residentEmail = resident.email;
                            }
                        });
                    }
                }
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    getBuildingNameById(id): string {
        let name = '';

        this.maintenanceCalendarService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(
            suite => (
                {value: suite.id, optionText: suite.name}
            )
        );
    }

    showCalendarDatepicker(dateToSet): void {
        if(!this.gettingAmenityForEditing && !(dateToSet == 'endDay' && !this.data.day)) {
            this.showCustomRepeatWindow = false;
            this.showCalendarDatePicker = !this.showCalendarDatePicker;
            if (this.showCalendarDatePicker) {
                this.dateToSet = dateToSet;
                setTimeout(() => {
                    const that = this;
                    $('#modalCalendar').fullCalendar(this.calendarOptions);
                    $('#modalCalendar').on('click', function (event) {
                        that.onDayClick(event);
                    });
                    if (dateToSet == 'endDay' && this.data.day) {
                        const goToDate = moment(this.data.endDay ? this.data.endDay.split('.')[1] + '.' + this.data.endDay.split('.')[0] + '.' + this.data.endDay.split('.')[2] :
                            this.data.day.split('.')[1] + '.' + this.data.day.split('.')[0] + '.' + this.data.day.split('.')[2], 'MM.DD.YYYY');
                        $('#modalCalendar').fullCalendar('gotoDate', goToDate);
                    } else if (dateToSet == 'day' && this.data.day) {
                        const goToDate = moment(this.data.day.split('.')[1] + '.' + this.data.day.split('.')[0] + '.' + this.data.day.split('.')[2], 'MM.DD.YYYY');
                        $('#modalCalendar').fullCalendar('gotoDate', goToDate);
                    }
                }, 150);
                setTimeout(() => {
                    this.modifyCalendarHeaderRow();
                    this.getEventsAndDayColoringsForMonthSelected(this.dateToSet);
                }, 300);
            }
        } else if(dateToSet == 'endDay' && !this.data.day && this.showCalendarDatePicker)
            this.showCalendarDatePicker = false;
    }

    modifyCalendarHeaderRow(): void {
        const headerRowCells = document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;
        for(let i = 0; i < headerRowCells.length; i++)
            (<any>headerRowCells[i]).innerText = (<any>headerRowCells[i]).innerText.substr(0,  1);
    }

    modifyCalendarCellsColoring(dateToSet): void {
        this.showCalendarSpinner = true;
        const daysRows = document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;
        for(let m = 0; m < daysRows.length; m++) {
            const daysInRow = daysRows[m].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes;
            for(let n = 0; n < daysInRow.length; n++) {
                const tableCell = (<any>daysInRow[n]);
                if(tableCell.classList && tableCell.classList.value.indexOf('fc-day-top') != -1) {
                    if(tableCell.innerText <= this.arrayForCalendarColoring.length) {
                        tableCell.classList += ' ' + (this.arrayForCalendarColoring[parseInt(tableCell.innerText) - 1].toLowerCase()).replace(' ', '-');
                        tableCell.childNodes[0].classList += ' ' + (this.arrayForCalendarColoring[parseInt(tableCell.innerText) - 1].toLowerCase()).replace(' ', '-');
                        const calendarDay = parseInt(tableCell.innerText);
                        const calendarMonth = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[0]);
                        const calendarYear = parseInt((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[1]);
                        if(dateToSet == 'endDay' && (new Date(calendarYear, calendarMonth, calendarDay) < new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])))) {
                            tableCell.classList += ' ' + 'closed';
                            tableCell.childNodes[0].classList += ' ' + 'closed';
                        }
                        if(dateToSet == 'endDay' && this.amenityType == 'hourly' && this.nextDayEndTimes.length &&
                            ((new Date(calendarYear, calendarMonth, calendarDay).getTime() - new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime()) > 60000 * 60 * 24)) {
                            tableCell.classList += ' ' + 'closed';
                            tableCell.childNodes[0].classList += ' ' + 'closed';
                        }
                        if(dateToSet == 'endDay' && this.amenityType == 'daily' && (new Date(calendarYear, calendarMonth, calendarDay).getTime() == new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime())){
                            tableCell.classList += ' ' + 'closed';
                            tableCell.childNodes[0].classList += ' ' + 'closed';
                        }
                    }
                }
            }
        }
        this.showCalendarSpinner = false;
        (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = false;
        (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = false;
    }

    onDayClick(event): void {
        let element;
        let dayFindElement;
        if(event.toElement) {
            element = event.toElement;
            dayFindElement = event.toElement.offsetParent;
        } else if(event.target) {
            element = event.target;
            dayFindElement = event.target.parentElement;
        }
        if(element.className.indexOf('fc-day-number') != -1
            && element.className.indexOf(' booked') == -1
            && element.className.indexOf('closed') == -1
            && !this.showCalendarSpinner
        ) {
            this.startHour = '';
            this.endHour = '';
            this.timeSlot = '';
            let month = (<any>document.getElementsByClassName('fc-center')).length > 1 ?  (<any>document.getElementsByClassName('fc-center')[1].childNodes[0].childNodes[1]).innerHTML : (<any>document.getElementsByClassName('fc-center')[0].childNodes[0].childNodes[1]).innerHTML;
            const day = element.innerText;
            const year = month.substr(month.indexOf(' ') + 1, 4);
            month = this.monthsArray.indexOf(month.substr(0, month.indexOf(' '))) + 1;
            if(this.dateToSet == 'day')
                this.maintenanceCalendarService.prefilledDateFromCaledar = '';
            this.data[this.dateToSet] = ((day < 10 ? '0' + day : day) + '.' + (month < 10 ? '0' + month : month) + '.' +  year);
            if(this.dateToSet == 'day' && this.data.endDay)
                this.data.endDay = '';
            if(this.dateToSet == 'day' && this.amenityType == 'hourly')
                this.data.endDay = this.data.day;
            this.showCalendarDatePicker = false;
            if(this.amenityType == 'hourly' || this.amenityType == 'range') {
                this.showTimeSelectSpinner = true;
                let startDateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1])-1, parseInt(this.data.day.split('.')[0]));
                startDateForSending = new Date(new Date(startDateForSending).getTime() - new Date(startDateForSending).getTimezoneOffset() * 60000);
                let endDateForSending = new Date(new Date(startDateForSending).setDate(new Date(startDateForSending).getDate() + 2));
                let url = `/v1/booking_schedule.json?start_date=${startDateForSending.toISOString()}&end_date=${endDateForSending.toISOString()}&amenity_id=${this.data.amenity}&result_type=${this.dateToSet == 'day' ? 'date_from' : 'date_to'}`;
                if(this.dateToSet == 'endDay')
                    url += `&booking_date_from=${startDateForSending.toISOString()}`;
                this.api.get('domainAmenities', url).subscribe(
                    res => {
                        this.selectedDayBookings = [];
                        this.selectedDayBookings = JSON.parse(res._body)[0].bookings;
                        this.selectedEndDayBookings = [];
                        this.selectedEndDayBookings = JSON.parse(res._body)[1].bookings;
                        this.showTimeSelectSpinner = false;
                    },
                    error => this.api.errorHandler(error, 'Failed get Bookings for day selected')
                );
                if(this.dateToSet == 'day') {
                    this.nextDayEndTimes = [];
                    if (dayFindElement.classList.value.indexOf('fc-mon') != -1)
                        this.daySelectedNumber = 1;
                    if (dayFindElement.classList.value.indexOf('fc-tue') != -1)
                        this.daySelectedNumber = 2;
                    if (dayFindElement.classList.value.indexOf('fc-wed') != -1)
                        this.daySelectedNumber = 3;
                    if (dayFindElement.classList.value.indexOf('fc-thu') != -1)
                        this.daySelectedNumber = 4;
                    if (dayFindElement.classList.value.indexOf('fc-fri') != -1)
                        this.daySelectedNumber = 5;
                    if (dayFindElement.classList.value.indexOf('fc-sat') != -1)
                        this.daySelectedNumber = 6;
                    if (dayFindElement.classList.value.indexOf('fc-sun') != -1)
                        this.daySelectedNumber = 7;
                    this.getOvernightEndHours();
                }
            }
        } else if((element.className.indexOf('fc-icon-left-single-arrow') != -1 ||
                   element.className.indexOf('fc-icon-right-single-arrow') != -1 ||
                   element.className.indexOf('fc-prev-button') != -1 ||
                   element.className.indexOf('fc-next-button') != -1) && !this.showCalendarSpinner) {
            this.modifyCalendarHeaderRow();
            this.getEventsAndDayColoringsForMonthSelected(this.dateToSet);
        }
    }

    moveToTheNextStep(moveTo): void {
        if(this.step == 'details')
            this.showCalendarDatePicker = false;

        if(moveTo == 'amenity') {
            if(!this.isEditMode)
                this.step = moveTo;
        }
        if(moveTo == 'terms') {
            if(this.step == 'amenity') {
                if(!this.data.buildingId || !this.data.amenity)
                    return;
            }
            this.step = moveTo;
            this.form.submitted = false;
        }
        if(moveTo == 'details') {
            if(this.data.buildingId && this.data.amenity &&
               ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage)) {
                this.step = moveTo;
                this.form.submitted = false;
            }
        }
        if(moveTo == 'disclaimer') {
            if(((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.amenityType && ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                (this.amenityType == 'hourly' ? this.data.day && this.data.endDay && this.startHour && this.endHour : true) &&
                (this.amenityType == 'range' ? this.timeSlot : true))
            ) {
                this.form.submitted = false;
                this.step = moveTo;
            }
        }
        if(moveTo == 'payment') {
            if(((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                    (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.data.day && this.data.amenity &&
                ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                (this.amenityType == 'hourly' ? this.data.day && this.data.endDay
                                                && this.startHour && this.endHour : true) &&
                (this.amenityType == 'range' ? this.timeSlot : true))) {
                this.form.submitted = false;
                this.step = moveTo;
            }
        }
        if(moveTo == 'summary') {
            if(((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.amenityType && ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                (this.amenityType == 'hourly' ? this.data.day && this.data.endDay
                                                && this.startHour && this.endHour : true) &&
                (this.amenityType == 'range' ? this.timeSlot : true) &&
                !(this.data.paymentMethod == 'credit_card' && !this.creditCardToken))
            ) {
                this.form.submitted = false;
                this.step = moveTo;
            }

            if(this.data.payments && this.data.paymentMethod == 'credit_card' && !this.creditCardToken)
                toastr.warning('Credit Card details must be filled and applied before moving forward.');
        }
    }

    selectAmenity(amenity): void {
        this.termsAndConditions = '';
        this.disclaimerText = '';
        this.disclaimerHideFromStaffInterface = 0;
        this.amenityConfirmationMessage = '';
        this.data.amenity = amenity.id;
        this.amenityName = amenity.name;
        this.legalAgreementStatus = null;
        this.disclaimerStatus = null;

        if((!this.authService.userIsResident && amenity.legalAgreementStatus && amenity.legalAgreement && !amenity.legalAgreementHideFromStaffInterface)
            || (this.authService.userIsResident && amenity.legalAgreementStatus && amenity.legalAgreement)) {
            this.legalAgreementStatus = amenity.legalAgreementStatus;
            this.termsAndConditions = amenity.legalAgreement;
            this.amenityConfirmationMessage = amenity.confirmationMessage;
        }
        if((!this.authService.userIsResident && amenity.disclaimerStatus && !amenity.disclaimerHideFromStaffInterface)
            || (this.authService.userIsResident && amenity.disclaimerStatus)) {
            this.disclaimerStatus = amenity.disclaimerStatus;
            this.disclaimerText = amenity.disclaimer;
            this.disclaimerHideFromStaffInterface = amenity.disclaimerHideFromStaffInterface;
        }

        this.data.managementOverride = false;
        this.data.paymentMethod = '';
        this.availablePaymentMethods = [];
        this.data.day = this.maintenanceCalendarService.prefilledDateFromCaledar ? this.maintenanceCalendarService.prefilledDateFromCaledar : '';
        this.data.endDay = '';
        this.data.uses = '';
        this.timeSlot = '';
        this.originalRules = null;
        this.startHour = '';
        this.endHour = '';
        this.checkInHour = '';
        this.checkOutHour = '';
        this.amenityFees = [];
        this.bookingMinHour = null;
        this.bookingMaxHour = null;
        this.amenityType = amenity.timeSequenceType;
        this.daySelectedNumber = this.maintenanceCalendarService.prefilledDateFromCaledar ? this.daySelectedNumber : null;
        this.originalRules = amenity.rule;
        this.availableUses = amenity.uses;
        this.overrideAvailable = amenity.managementOverride;
        this.multipleBookingAllowed = amenity.multipleBooking;
        this.minTimeForAdvancedBooking = amenity.minTimeForAdvancedBooking;
        if(this.availableUses.length)
            this.data.uses = this.availableUses[0];
        if(this.bookingType != 'event') {
            amenity.fees.filter(payment => {
                if (payment.active) {
                    this.amenityFees.push({
                        id: payment.id,
                        active: payment.active,
                        name: payment.name,
                        status: payment.status,
                        amount: payment.amount,
                        required: payment.required,
                        include: payment.required ? true : false,
                        refundable: payment.refundable,
                        pmtAtTime: payment.pmtAtTime,
                        pmtHourly: payment.pmtHourly
                    });
                }
            });
        }
        if(amenity.paymentAcceptCash)
            this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
        if(amenity.paymentAcceptCheques)
            this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
        if(amenity.paymentAcceptCreditCards)
            this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
        if(amenity.paymentAcceptCustomType)
            this.availablePaymentMethods.push({value: 'custom_type', displayName: amenity.paymentCustomTypeName});
        if(amenity.defaultPaymentMethod)
            this.data.paymentMethod = amenity.defaultPaymentMethod;

        if(this.amenityType == 'daily') {
            this.checkInHour = amenity.rule.checkInTime;
            this.checkOutHour = amenity.rule.checkOutTime;
        }
        if(this.amenityType == 'hourly') {
            this.generateTimeSlotValues(amenity.rule.weekDays, amenity.rule.timeStep);
            this.bookingMaxHour = amenity.rule.bookingMaxHour;
            this.bookingMinHour = amenity.rule.bookingMinHour;
            if(this.maintenanceCalendarService.prefilledDateFromCaledar)
                this.getOvernightEndHours();
        }
        if(this.amenityType == 'range')
            this.generateRangeSlotValues(amenity.rule.weekDays);
        if((this.amenityType == 'hourly' || this.amenityType == 'range') && this.maintenanceCalendarService.prefilledDateFromCaledar) {
            this.showTimeSelectSpinner = true;
            let startDateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
            startDateForSending = new Date(new Date(startDateForSending).getTime() - new Date(startDateForSending).getTimezoneOffset() * 60000);
            let endDateForSending = new Date(new Date(startDateForSending).setDate(new Date(startDateForSending).getDate() + 2));
            let url = `/v1/booking_schedule.json?start_date=${startDateForSending.toISOString()}&end_date=${endDateForSending.toISOString()}&amenity_id=${this.data.amenity}&result_type=date_from`;
            this.api.get('domainAmenities', url).subscribe(
                res => {
                    this.selectedDayBookings = [];
                    this.selectedDayBookings = JSON.parse(res._body)[0].bookings;
                    this.selectedEndDayBookings = [];
                    this.selectedEndDayBookings = JSON.parse(res._body)[1].bookings;
                    this.showTimeSelectSpinner = false;
                },
                error => this.api.errorHandler(error, 'Failed get Bookings for day selected')
            );
        }
    }

    generateTimeSlotValues(dayTimes, timestep): void {
        this.timeSlotSelectValues = [];
        dayTimes.forEach(time => {
            let timesArray = [];
            time.dayHours.forEach(dayHour => {
                const startHour = this.getTimeInZeroTimezone(dayHour.minHour).getHours();
                const endHour = this.getTimeInZeroTimezone(dayHour.maxHour).getHours();
                const startMinutes = new Date(dayHour.minHour).getMinutes();
                const endMinutes = new Date(dayHour.maxHour).getMinutes() + 1;
                for (let i = startHour; i < (endHour == 0 ? 24 : endHour + 1); i++) {
                    for (let j = startMinutes; j < ((i + 1 == endHour + 1) ? endMinutes : 60); j += timestep) {
                        if (j < 60) {
                            const hour = (i <= 12 ? (i == 0 ? 12 : i) : i - 12);
                            const minutes = (j < 10 ? '0' + j : j);
                            const amPm = (i < 12 || i == 24 ? ' AM' : ' PM');
                            timesArray.push((hour < 10 ? '0' + hour : hour) + ':' + minutes + amPm);
                        }
                    }
                }
            });
            this.timeSlotSelectValues.push({day: time.dayNumber, times: timesArray});
        });
    }

    generateRangeSlotValues(ranges): void {
        this.timeRangeSelectValues = [];
        ranges.forEach((range) => {
            let rangeArray = [];
            range.dayHours.forEach((hours) => {
                const startHour = this.getTimeInZeroTimezone(hours.minHour).getHours();
                const endHour = this.getTimeInZeroTimezone(hours.maxHour).getHours();
                const startMinutes = new Date(hours.minHour).getMinutes();
                const endMinutes = new Date(hours.maxHour).getMinutes();
                let rangeString = (startHour >= 10 ? (startHour > 12 ? startHour - 12  : startHour) : startHour != 0 ? startHour : 12).toString();
                rangeString += ':' + (startMinutes >= 10 ? startMinutes : '0' + startMinutes);
                rangeString += ' ' +  (startHour >= 12 && startHour != 24 ? 'PM' : 'AM');
                rangeString += ' - ';
                rangeString += (endHour >= 10 ? (endHour > 12 ? endHour - 12  : endHour) : endHour != 0 ? endHour : 12).toString();
                rangeString += ':' + (endMinutes >= 10 ? endMinutes : '0' + endMinutes);
                rangeString += ' ' +  (endHour >= 12 && endHour != 24 ? 'PM' : 'AM');
                rangeArray.push(rangeString);
            })
            this.timeRangeSelectValues.push({day: range.dayNumber, ranges: rangeArray});
        });
    }

    getRangeValuesIndexByDayNumber(): number {
        let returnNumber = -1;
        for(let i = 0; i < this.timeRangeSelectValues.length; i++) {
            if(this.timeRangeSelectValues[i].day == this.daySelectedNumber) {
                returnNumber = i;
                break;
            }
        }
        return returnNumber;
    }

    getTimesIndexByDayNumber(): number {
        let returnNumber = -1;
        for(let i = 0; i < this.timeSlotSelectValues.length; i++) {
            if(this.timeSlotSelectValues[i].day == this.daySelectedNumber) {
                returnNumber = i;
                break;
            }
        }
        return returnNumber;
    }

    isStartHourDisabled(hour): boolean {
        let disableOption = false;
        if(!this.data.managementOverride) {
            this.selectedDayBookings.filter((booking) => {
                const start = this.getTimeInZeroTimezone(booking.start);
                const end = this.getTimeInZeroTimezone(booking.end);
                let startTimeString = (start.getHours() >= 10 ?
                    (start.getHours() > 12 ? start.getHours() - 12 : start.getHours()) : '0' + start.getHours()).toString();
                startTimeString += ':' + (start.getMinutes() >= 10 ? start.getMinutes() : '0' + start.getMinutes());
                startTimeString += ' ' + (start.getHours() >= 12 ? 'PM' : 'AM');
                let endTimeString = (end.getHours() >= 10 ? (end.getHours() > 12 ? end.getHours() - 12 : end.getHours()) :
                    '0' + end.getHours()).toString();
                endTimeString += ':' + (end.getMinutes() >= 10 ? end.getMinutes() : '0' + end.getMinutes());
                endTimeString += ' ' + (end.getHours() >= 12 ? 'PM' : 'AM');
                if(!this.multipleBookingAllowed) {
                    if (start.getDate() < parseInt(this.data.day.split('.')[0])) {
                        if (new Date(`01/01/1970 ${hour}`) < new Date(`01/01/1970 ${endTimeString}`))
                            disableOption = true;
                    } else if (new Date(`01/01/1970 ${hour}`) >= new Date(`01/01/1970 ${startTimeString}`) &&
                        new Date(`01/01/1970 ${hour}`) < new Date(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${endTimeString}`))
                        disableOption = true;
                }

                if(this.originalRules.technicalBreak){
                    const number = +this.originalRules.technicalBreak.split(' ')[0];
                    const timeMeasurement = this.originalRules.technicalBreak.split(' ')[1];
                    const otherBookingStart = new Date(`01/01/1970 ${startTimeString}`);
                    const otherBookingEnd = new Date(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${endTimeString}`);
                    const checkedHour = new Date(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${hour}`);
                    const checkedHourPlusBreak = moment(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${hour}`).add(number, timeMeasurement).toDate();
                    if(otherBookingStart >= checkedHour && checkedHourPlusBreak > otherBookingStart)
                        disableOption = true;
                    if(otherBookingStart < checkedHour && moment(otherBookingEnd).add(number, timeMeasurement).toDate() > checkedHour)
                        disableOption = true;
                }
            });
            const startDate = new Date(
                parseInt(this.data.day.split('.')[2]),
                parseInt(this.data.day.split('.')[1]) - 1,
                parseInt(this.data.day.split('.')[0])
            ).getTime();
            const endDate = new Date(
                parseInt(this.data.endDay.split('.')[2]),
                parseInt(this.data.endDay.split('.')[1]) - 1,
                parseInt(this.data.endDay.split('.')[0])
            ).getTime();
            if (startDate != endDate) {
                this.originalRules.weekDays.filter((rule) => {
                    if (rule.dayNumber == this.daySelectedNumber) {
                        rule.dayHours.filter((hours) => {
                            const minHour = this.getTimeInZeroTimezone(hours.minHour);
                            const maxHour = this.getTimeInZeroTimezone(hours.maxHour);
                            if (!(new Date(`01/01/1970 ${hour}`) >= minHour && new Date(`01/01/1970 ${hour}`) <= maxHour)) {
                                if (hours.maxHour == '1970-01-02T00:00:00+00:00')
                                    disableOption = true;
                            }
                        });
                    }
                });
            }
            if(this.minTimeForAdvancedBooking && this.data.day) {
                const hours = hour.split(' ')[1] == 'PM' ? parseInt(hour.split(':')[0]) + 12 : hour.split(':')[0];
                const minutes = hour.split(':')[1].split(' ')[0];
                const year = +this.data.day.split('.')[2];
                const month = parseInt(this.data.day.split('.')[1]) - 1;
                const day = +this.data.day.split('.')[0];
                let optionTime = new Date(year, month, day);
                optionTime.setHours(hours);
                optionTime.setMinutes(minutes);
                const minAllowedTime = moment().add(this.minTimeForAdvancedBooking.split(' ')[0], this.minTimeForAdvancedBooking.split(' ')[1])._d;
                if(optionTime < minAllowedTime)
                    disableOption = true;
            }
        }
        const bookingStartDate = new Date(
            parseInt(this.data.day.split('.')[2]),
            parseInt(this.data.day.split('.')[1]) - 1,
            parseInt(this.data.day.split('.')[0])
        ).getTime();
        // NEEDS FIX ON BACK END FOR KNOWING CLIENTS TIMEZONE!!! Disables the time that is earlier than current time.
        if(bookingStartDate == new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()) {
            // const currentDate = new Date(new Date().getTime() + new Date().getTimezoneOffset() * 60000);
            const currentDate = new Date();
            const currentTime = new Date(`01/01/1970 ${currentDate.getHours() + ':' + currentDate.getMinutes()}`);
            if(currentTime > (new Date(`01/01/1970 ${hour}`)))
                disableOption = true;
        }
        return disableOption;
    }

    isEndHourDisabled(hour): boolean {
        let disableOption = false;
        if (new Date(`01/01/1970 ${hour}`) <= new Date(`01/01/1970 ${this.startHour}`))
            disableOption = true;
        if(!this.data.managementOverride) {
            this.selectedDayBookings.filter((booking) => {
                const start = this.getTimeInZeroTimezone(booking.start);
                const end = this.getTimeInZeroTimezone(booking.end);
                let startTimeString = (start.getHours() >= 10 ?
                    (start.getHours() >= 12 ? start.getHours() - 12 : start.getHours()) : '0' + start.getHours()).toString();
                startTimeString += ':' + (start.getMinutes() >= 10 ? start.getMinutes() : '0' + start.getMinutes());
                startTimeString += ' ' + (start.getHours() >= 12 ? 'PM' : 'AM');
                let endTimeString = (end.getHours() >= 10 ? (end.getHours() >= 12 ? end.getHours() - 12 : end.getHours()) :
                    '0' + new Date(booking.end).getHours()).toString();
                endTimeString += ':' + (end.getMinutes() >= 10 ? end.getMinutes() : '0' + end.getMinutes());
                endTimeString += ' ' + (end.getHours() >= 12 ? 'PM' : 'AM');
                if(!this.multipleBookingAllowed) {
                    if (start.getDate() === end.getDate()) {
                        if (new Date(`01/01/1970 ${hour}`) > new Date(`01/01/1970 ${startTimeString}`) &&
                            new Date(`01/01/1970 ${hour}`) <= new Date(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${endTimeString}`))
                            disableOption = true;
                        if (new Date(`01/01/1970 ${this.startHour}`) < new Date(`01/01/1970 ${startTimeString}`) &&
                            new Date(`01/01/1970 ${hour}`) >= new Date(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${endTimeString}`))
                            disableOption = true;
                    } else {
                        if (new Date(`01/01/1970 ${hour}`) < new Date(`01/01/1970 ${endTimeString}`))
                            disableOption = true;
                    }
                }

                if(this.originalRules.technicalBreak){
                    const number = +this.originalRules.technicalBreak.split(' ')[0];
                    const timeMeasurement = this.originalRules.technicalBreak.split(' ')[1];
                    const otherBookingStart = new Date(`01/01/1970 ${startTimeString}`);
                    const checkedHour = new Date(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${hour}`);
                    const checkedHourPlusBreak = moment(`01/${start.getDate() != end.getDate() ? '02' : '01'}/1970 ${hour}`).add(number, timeMeasurement).toDate();
                    if(otherBookingStart >= checkedHour && checkedHourPlusBreak > otherBookingStart)
                        disableOption = true;
                }
            });
            if (this.bookingMinHour) {
                if (new Date(`01/01/1970 ${hour}`).getTime() - new Date(`01/01/1970 ${this.startHour}`).getTime() < this.bookingMinHour * 3600000)
                    disableOption = true;
            }
            if (this.bookingMaxHour) {
                if (new Date(`01/01/1970 ${hour}`).getTime() - new Date(`01/01/1970 ${this.startHour}`).getTime() > this.bookingMaxHour * 3600000)
                    disableOption = true;
            }
            this.originalRules.weekDays.filter((rule) => {
                if (rule.dayNumber == this.daySelectedNumber) {
                    rule.dayHours.filter((hours) => {
                        const minHour = this.getTimeInZeroTimezone(hours.minHour);
                        const maxHour = this.getTimeInZeroTimezone(hours.maxHour);
                        if (new Date(`01/01/1970 ${this.startHour}`) >= minHour && new Date(`01/01/1970 ${this.startHour}`) <= maxHour) {
                            if (!(new Date(`01/01/1970 ${hour}`) >= minHour && new Date(`01/01/1970 ${hour}`) <= maxHour))
                                disableOption = true;
                        }
                    });
                }
            });
        }
        return disableOption;
    }

    isRangeDisabled(range): boolean {
        let flag = false;
        if(!this.data.managementOverride && !this.multipleBookingAllowed) {
            let dateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
            let endDateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
            if(range.split('- ')[1] == '12:00 AM')
                endDateForSending = new Date(new Date(endDateForSending).setDate(new Date(endDateForSending).getDate() + 1));
            const startTime = this.setDateAndTime(dateForSending, range.split(' -')[0]);
            const endTime = this.setDateAndTime(endDateForSending, range.split('- ')[1]);
            this.selectedDayBookings.filter((booking) => {
                if (startTime.getTime() == new Date(booking.start).getTime() && endTime.getTime() == new Date(booking.end).getTime())
                    flag = true;
            });
        }
        let endDateForCheck = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
        endDateForCheck = new Date(new Date(endDateForCheck).getTime());
        if(range.split('- ')[1] == '12:00 AM')
            endDateForCheck = new Date(new Date(endDateForCheck).setDate(new Date(endDateForCheck).getDate() + 1));
        const rangeEndTime = this.setDateAndTime(endDateForCheck, range.split('- ')[1]);
        if(rangeEndTime < new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000))
            flag = true;
        return flag;
    }

    getFormattedPhone(phone): string {
        let phoneString = '';

        if(phone.length == 10)
            phoneString = phone.substr(0, 3) + ' ' + phone.substr(3, 3) + ' ' + phone.substr(6, 4);
        else if(phone.length == 11)
            phoneString = '+' + phone.substr(0, 1) + ' ' + phone.substr(1, 3) + ' ' + phone.substr(4, 3) + ' ' + phone.substr(7, 4);
        else
            phoneString = phone;

        return phoneString;
    }

    isContinueButtonDisabled(step): boolean {
        let isDisabled = true;

        if(step == 'amenity') {
            if(this.data.buildingId && this.data.amenity)
                isDisabled = false;
        }
        if(step == 'disclaimer') {
            if(this.amenityConfirmationMessage) {
                isDisabled = false;
            } else
                isDisabled = false;
        }
        if(step == 'details') {
            if(((this.data.suiteId || this.data.suiteNumber) && (this.data.residentId || this.data.residentFullName) || this.bookingType == 'event')
                && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true))
                isDisabled = false;
            if(this.authService.userIsResident && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true))
                isDisabled = false;
        }
        if(step == 'terms') {
            if(this.amenityConfirmationMessage) {
                if(this.data.acknowledgement)
                    isDisabled = false;
            } else
                isDisabled = false;
        }
        if(step == 'payment') {
            if(this.authService.userIsResident && this.data.amenity && this.data.day &&
                (this.amenityType == 'daily' ? this.data.endDay : true)) {
                    isDisabled = false;
                }

            if(((this.data.suiteId || this.data.suiteNumber) && (this.data.residentId || this.data.residentFullName) || this.bookingType == 'event')
                && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true)) {
                if(this.amenityConfirmationMessage) {
                    if(this.data.acknowledgement)
                        isDisabled = false;
                } else
                    isDisabled = false;
            }
        }
        if(step == 'summary') {
            if(((this.data.suiteId || this.data.suiteNumber) && (this.data.residentId || this.data.residentFullName) || this.bookingType == 'event')
               && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true)) {
                if(this.amenityConfirmationMessage) {
                    if(this.data.acknowledgement)
                        isDisabled = false;
                } else
                    isDisabled = false;
            }
            if(this.authService.userIsResident && this.data.amenity && this.data.day &&
                (this.amenityType == 'daily' ? this.data.endDay : true))
            isDisabled = false;
        }

        return isDisabled;
    }

    getEventsAndDayColoringsForMonthSelected(dateToSet): void {
        this.showCalendarSpinner = true;
        (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = true;
        (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = true;
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[0]);
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[1]);
        const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        let url = `/v1/booking_schedule.json?start_date=${startDateForSending.toISOString()}&end_date=${endDateForSending.toISOString()}&amenity_id=${this.data.amenity}&result_type=${dateToSet == 'day' ? 'date_from' : 'date_to'}`;
        if(dateToSet == 'endDay') {
            const booking_date_from = new Date(new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime() - new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTimezoneOffset() * 60000);
            url += `&booking_date_from=${booking_date_from.toISOString()}`;
        }
        if(!this.data.managementOverride) {
            this.api.get('domainAmenities', url).subscribe(
                res => {
                    this.arrayForCalendarColoring = [];
                    const entities = JSON.parse(res._body);
                    entities.filter(entity => {
                        this.arrayForCalendarColoring.push(entity.status);
                    });
                    this.modifyCalendarCellsColoring(dateToSet);
                },
                error => {
                    this.api.errorHandler(error, 'Failed get Bookings for month selected');
                    (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = false;
                    (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = false;
                }
            );
        } else
            this.modifyCalendarCellsColoringForOverrideMode(dateToSet);
    }

    modifyCalendarCellsColoringForOverrideMode(dateToSet) {
        let scheduledDays = [];
        if(this.amenityType == 'daily') {
            this.originalRules.weekDays.filter((value) => {
                scheduledDays.push(value.dayNumber);
            });
        } else if(this.amenityType == 'hourly') {
            this.timeSlotSelectValues.filter((value) => {
                scheduledDays.push(value.day);
            });
        } else if(this.amenityType == 'range') {
            this.timeRangeSelectValues.filter((value) => {
                scheduledDays.push(value.day);
            });
        }
        this.showCalendarSpinner = true;
        const daysRows = document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;
        for(let m = 0; m < daysRows.length; m++) {
            const daysInRow = daysRows[m].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes;
            for(let n = 0; n < daysInRow.length; n++) {
                const tableCell = (<any>daysInRow[n]);
                if(tableCell.classList && tableCell.classList.value.indexOf('fc-day-top') != -1) {
                    if(scheduledDays.indexOf(n === 0 ? 7 : n) != -1 || this.amenityType == 'daily') {
                        tableCell.classList += ' available';
                        tableCell.childNodes[0].classList += ' available';
                    } else {
                        tableCell.classList += ' ' + 'closed';
                        tableCell.childNodes[0].classList += ' ' + 'closed';
                    }
                    const calendarDay = parseInt(tableCell.innerText);
                    const calendarMonth = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[0]);
                    const calendarYear = parseInt((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[1]);
                    if(dateToSet == 'endDay' && (new Date(calendarYear, calendarMonth, calendarDay) < new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])))) {
                        tableCell.classList += ' ' + 'closed';
                        tableCell.childNodes[0].classList += ' ' + 'closed';
                    }
                    if(dateToSet == 'endDay' && this.amenityType == 'hourly' && this.nextDayEndTimes.length &&
                        ((new Date(calendarYear, calendarMonth, calendarDay).getTime() - new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime()) > 60000 * 60 * 24)) {
                        tableCell.classList += ' ' + 'closed';
                        tableCell.childNodes[0].classList += ' ' + 'closed';
                    }
                    if(dateToSet == 'endDay' && this.amenityType == 'daily' && (new Date(calendarYear, calendarMonth, calendarDay).getTime() == new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime())) {
                        tableCell.classList += ' ' + 'closed';
                        tableCell.childNodes[0].classList += ' ' + 'closed';
                    }
                    const currentDay = this.getTimeInZeroTimezone(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).getTime();
                    const calendarDayUTC = this.getTimeInZeroTimezone(new Date(calendarYear, calendarMonth, calendarDay)).getTime();
                    if(calendarDayUTC < currentDay) {
                        tableCell.classList += ' ' + 'closed';
                        tableCell.childNodes[0].classList += ' ' + 'closed';
                    }
                }
            }
        }
        this.showCalendarSpinner = false;
        (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = false;
        (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = false;
    }

    addDayToRepeatArray(day) {
        if(this.repeatOn.indexOf(day) == -1)
            this.repeatOn.push(day);
        else
            this.repeatOn.splice(this.repeatOn.indexOf(day), 1);
    }

    showCustomRepeat(): void {
        this.showCalendarDatePicker = false;
        this.showCustomRepeatWindow = true;
    }

    convertDayBookingStartEnd(dateValue, timeValue): any {
        const date = new Date(dateValue);
        const timeObj = this.getTimeInZeroTimezone(timeValue);
        const utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), timeObj.getHours(), timeObj.getMinutes());
        return new Date(utcDate);
    }

    changePaymentType(event): void {
        if(event == 'credit_card')
            this.amenityFees.filter(fee => fee.status = false);
        this.creditCardToken = null;
    }

    getTotalRefundableValue(): any {
        let returnValue = 0;
        this.amenityFees.filter((fee) => {
            if(fee.include && fee.active && fee.refundable)
                returnValue += parseFloat(fee.amount.replace(',', '.'));
        })
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getIndividualReservationProcessingFee(fee): any {
        return fee != '0.00' ? ((((parseFloat(fee) * 1.01) + 0.3) / 0.971) - parseFloat(fee)) : 0;
    }

    getIndividualTotal(fee): any {
        let total = '';
        if(fee.pmtAtTime)
            total = (this.getStartEndDayDifference() * parseFloat(fee.amount)).toString();
        else if(fee.pmtHourly)
            total = (this.getStartEndHourDifference() * parseFloat(fee.amount)).toString();
        else
            total = fee.amount;
        return parseFloat((total + (!fee.refundable ? this.getIndividualReservationProcessingFee(total) : 0))).toFixed(2);
    }

    getReservationProcessingFeeValue(): any {
        let returnValue = 0;
        returnValue = this.getTotalPaymentValue() != '0.00' ? ((parseFloat(this.getTotalPaymentValue()) * 1.01 + 0.3) / 0.971) - parseFloat(this.getTotalPaymentValue()) : 0;
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getTotalPaymentValue(): any {
        let returnValue = 0;
        this.amenityFees.filter((fee) => {
            if(fee.include && fee.active && !fee.refundable) {
                if(!fee.pmtAtTime && !fee.pmtHourly)
                    returnValue += parseFloat(fee.amount.replace(',', '.'));
                else if(fee.pmtAtTime)
                    returnValue += parseFloat(fee.amount.replace(',', '.')) * this.getStartEndDayDifference();
                else if(fee.pmtHourly)
                    returnValue += parseFloat(fee.amount.replace(',', '.')) * this.getStartEndHourDifference();
            }
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getTotalCharged(): any {
        return parseFloat((parseFloat(this.getTotalPaymentValue()) + (this.data.paymentMethod == 'credit_card' ? parseFloat(this.getReservationProcessingFeeValue()) : 0)).toString()).toFixed(2);
    }

    getStartEndDayDifference(): number {
        return Math.round((new Date(parseInt(this.data.endDay.split('.')[2]), parseInt(this.data.endDay.split('.')[1]) - 1, parseInt(this.data.endDay.split('.')[0])).getTime() -
            new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime()) / (24 * 3600000));
    }

    getStartEndHourDifference(): number {
        const startDay = `${this.data.day.slice(-4)}/${this.data.day.slice(3, 5)}/${this.data.day.slice(0, 2)}`;
        const endDay = `${this.data.endDay.slice(-4)}/${this.data.endDay.slice(3, 5)}/${this.data.endDay.slice(0, 2)}`;
        return (+moment.utc(moment(endDay + ` ${this.endHour}`).diff(moment(startDay + ` ${this.startHour}`))).format('x')) / (60 * 60 * 1000);
    }

    getPaymentsFormatted(): Array<any> {
        let formatted = [];
        this.amenityFees.filter((fee) => {
           let total = '';
           if(fee.pmtAtTime)
               total = (this.getStartEndDayDifference() * parseFloat(fee.amount)).toString();
           else if(fee.pmtHourly)
               total = (this.getStartEndHourDifference() * parseFloat(fee.amount)).toString();
           else
               total = fee.amount;
           formatted.push({
               fee: fee.id,
               chosen: fee.include ? 1 : 0,
               name: fee.name,
               status: this.data.id ? undefined : (fee.status ? 1 : 0),
               paymentType: this.data.paymentMethod,
               amount: fee.amount,
               total: total,
               refundable: fee.refundable ? 1 : 0,
               cardToken: this.data.paymentMethod == 'credit_card' ? this.creditCardToken : undefined
           });
        });
        return formatted;
    }

    ifRequired(fee) {
        let required = false;
        this.amenityFees.filter((amenityFee) => {
            if(amenityFee.name == fee.name)
                required = amenityFee.required;
        });
        return required;
    }

    setCard(card) {
        this.creditCardToken = card;
    }

    onStripeSuccess() {
        this.moveToTheNextStep('summary');
    }

    clickStripeHiddenButton() {
        document.getElementById('confirmStripeCreditCard').click();
    }

    getOvernightEndHours(): void {
        this.nextDayEndTimes = [];
        let dayEndsAtMidnight = false;
        let index = -1;
        for(let i = 0; i < this.originalRules.weekDays.length; i++) {
            if(this.originalRules.weekDays[i].dayNumber == this.daySelectedNumber) {
                this.originalRules.weekDays[i].dayHours.filter((hours) => {
                    if(hours.maxHour == '1970-01-02T00:00:00+00:00')
                        dayEndsAtMidnight = true;
                });
            }
        }
        if(dayEndsAtMidnight) {
            for (let i = 0; i < this.originalRules.weekDays.length; i++) {
                if (this.originalRules.weekDays[i].dayNumber == (this.daySelectedNumber == 7 ? 1 : this.daySelectedNumber + 1)) {
                    index = i;
                    break;
                }
            }
        }
        if(index != -1) {
            let overnightDayHours = null;
            this.originalRules.weekDays[index].dayHours.filter((hours) => {
                if(new Date(hours.minHour).getTime() == 0)
                    overnightDayHours = hours;
            });
            if(overnightDayHours) {
                const timestep = this.originalRules.timeStep;
                const minHour = new Date(overnightDayHours.minHour);
                const maxHour = new Date(overnightDayHours.maxHour);
                const startHour = this.getTimeInZeroTimezone(minHour).getHours();
                const endHour = this.getTimeInZeroTimezone(maxHour).getHours();
                const startMinutes = minHour.getMinutes();
                const endMinutes = maxHour.getMinutes() + 1;
                for (let i = startHour; i < endHour + 1; i++) {
                    for (let j = startMinutes; j < ((i + 1 == endHour + 1) ? endMinutes : 60); j += timestep) {
                        if (j < 60) {
                            const hour = (i <= 12 ? (i == 0 ? 12 : i) : i - 12);
                            const minutes = (j < 10 ? '0' + j : j);
                            const amPm = (i < 12 || i == 24 ? ' AM' : ' PM');
                            this.nextDayEndTimes.push((hour < 10 ? '0' + hour : hour) + ':' + minutes + amPm);
                        }
                    }
                }
            } else
                this.nextDayEndTimes.push('12:00 AM');
        } else
            this.data.endDay = this.data.day;
    }

    isNextDayEndHourDisabled(hour): boolean {
        let disableOption = false;
        if(!this.data.managementOverride) {
            if(!this.multipleBookingAllowed) {
                this.selectedEndDayBookings.filter((booking) => {
                    const start = this.getTimeInZeroTimezone(booking.start);
                    const end = this.getTimeInZeroTimezone(booking.end);
                    let startTimeString = (start.getHours() >= 10 ?
                        (start.getHours() >= 12 ? start.getHours() - 12 : start.getHours()) : '0' + start.getHours()).toString();
                    startTimeString += ':' + (start.getMinutes() >= 10 ? start.getMinutes() : '0' + start.getMinutes());
                    startTimeString += ' ' + (start.getHours() >= 12 ? 'PM' : 'AM');
                    let endTimeString = (end.getHours() >= 10 ? (end.getHours() >= 12 ? end.getHours() - 12 : end.getHours()) :
                        '0' + end.getHours()).toString();
                    endTimeString += ':' + (end.getMinutes() >= 10 ? end.getMinutes() : '0' + end.getMinutes());
                    endTimeString += ' ' + (end.getHours() >= 12 ? 'PM' : 'AM');
                    if (new Date(`01/02/1970 ${hour}`) > new Date(`01/01/1970 ${startTimeString}`) &&
                        new Date(`01/02/1970 ${hour}`) <= new Date(`01/02/1970 ${endTimeString}`))
                        disableOption = true;
                });
                this.selectedDayBookings.filter((booking) => {
                    const start = this.getTimeInZeroTimezone(booking.start);
                    const end = this.getTimeInZeroTimezone(booking.end);
                    let startTimeString = (start.getHours() >= 10 ?
                        (start.getHours() >= 12 ? start.getHours() - 12 : start.getHours()) : '0' + start.getHours()).toString();
                    startTimeString += ':' + (start.getMinutes() >= 10 ? start.getMinutes() : '0' + start.getMinutes());
                    startTimeString += ' ' + (start.getHours() >= 12 ? 'PM' : 'AM');
                    let endTimeString = (end.getHours() >= 10 ? (end.getHours() >= 12 ? end.getHours() - 12 : end.getHours()) :
                        '0' + end.getHours()).toString();
                    endTimeString += ':' + (end.getMinutes() >= 10 ? end.getMinutes() : '0' + end.getMinutes());
                    endTimeString += ' ' + (end.getHours() >= 12 ? 'PM' : 'AM');
                    if(new Date(`01/01/1970 ${this.startHour}`) < new Date(`01/01/1970 ${startTimeString}`) &&
                        new Date(`01/02/1970 ${hour}`) >= new Date(`01/01/1970 ${endTimeString}`))
                        disableOption = true;
                });
            }
            if (this.bookingMinHour) {
                if (new Date(`01/02/1970 ${hour}`).getTime() - new Date(`01/01/1970 ${this.startHour}`).getTime() < this.bookingMinHour * 3600000)
                    disableOption = true;
            }
            if (this.bookingMaxHour) {
                if (new Date(`01/02/1970 ${hour}`).getTime() - new Date(`01/01/1970 ${this.startHour}`).getTime() > this.bookingMaxHour * 3600000)
                    disableOption = true;
            }
        }

        return disableOption;
    }

    endDateEqualsStartDate(): boolean {
        let flag = true;
        if(this.data.endDay) {
            const startDate = new Date(
                parseInt(this.data.day.split('.')[2]),
                parseInt(this.data.day.split('.')[1]),
                parseInt(this.data.day.split('.')[0])
            ).getTime();
            const endDate = new Date(
                parseInt(this.data.endDay.split('.')[2]),
                parseInt(this.data.endDay.split('.')[1]),
                parseInt(this.data.endDay.split('.')[0])
            ).getTime();
            if(startDate != endDate)
                flag = false;
        }
        return flag;
    }

    removePaidStatus(event, fee) {
        if(!event)
            fee.status = 0;
    }

    calculateCurrentProgressBarLength(): string {
        const termsAndConsitionsStepExist = this.termsAndConditions || this.amenityConfirmationMessage;
        const paymentStepExist = this.availablePaymentMethods.length  && this.amenityFees.length;
        if(this.step == 'amenity') {
            if(!paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '17%';
            if( paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '13%';
            if( paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '11%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '11%';
            if( paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '11%';
            if(!paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '13%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '13%';
            if( paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '9%';
        }

        if(this.step == 'disclaimer') {
            if(!paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '30%';
            if( paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '30%';
            if(!paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '63%';
            if( paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '59%';
        }
        if(this.step == 'details') {
            if(!paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '50%';
            if( paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '38%';
            if( paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '50%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '50%';
            if( paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '50%';
            if(!paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '38%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '38%';
            if( paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '42%';
        }
        if(this.step == 'terms') {
            if( paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '29%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '71%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '61%';
            if( paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '24%';
        }
        if(this.step == 'payment') {
            if( paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '63%';
            if( paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '70%';
            if( paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '71%';
            if( paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '76%';
        }
        if(this.step == 'summary') {
            if(!paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '84%';
            if( paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '88%';
            if( paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '91%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '91%';
            if( paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '91%';
            if(!paymentStepExist && !termsAndConsitionsStepExist &&  this.disclaimerText) return '88%';
            if(!paymentStepExist &&  termsAndConsitionsStepExist && !this.disclaimerText) return '88%';
            if( paymentStepExist &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '92%';
        }
    }

    overrideSettingChanged(event) {
        this.showCalendarDatePicker = false;
        if(!event) {
            this.data.day = '';
            this.data.endDay = '';
        }
    }

    getTimeInZeroTimezone(date): any {
        return new Date(new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60000);
    }

    imageIsSvg(amenityImage) {
        return amenityImage.indexOf('.svg') != -1;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-modal/maintenance-calendar-modal.component.ts